module.exports = __webpack_public_path__ + "media/images/logo_lorenza-9e466dfa52e4a0b4312497e7696b387f.png";